import request from '@/utils/request'


/**
 * 合并文件分块
 * @param params
 */
export function chunkFile(params) {
    return request({
        url: 'api/file/chunk',
        method: 'post',
        data: params
    })
}

/**
 * 合并文件分块
 * @param params
 */
export function mergeFile(params) {
    return request({
        url: 'api/file/merge',
        method: 'post',
        data: params
    })
}